import styled from 'styled-components'

export const AnswersWrapper = styled.div`
  padding-left: 20px;
`
